import { type TypedDocumentNode, gql } from '@apollo/client';

import type { minimalCollectionLayout_cardCollection } from './__generated__/data.graphql';

export const minimalCollectionLayout_cardCollectionFragment = gql`
  fragment minimalCollectionLayout_cardCollection on CardCollection {
    slug
    team: anyTeam {
      slug
      name
      pictureUrl
      styleGuideColor
    }
  }
` as TypedDocumentNode<minimalCollectionLayout_cardCollection>;
